import i18n from "@/locales";

export default [
  {
    path: "/h5-to-app-test",
    component: () => import(/* webpackChunkName: "h5-page" */ "@/views/h5-to-app-test/index.vue"),
    meta: {
      title: 'h5ToAppTest',
      isH5Page: true,
      isH5Login: true
    }
  },
  {
    path: "/h5-page-login",
    name: "h5PageLogin",
    component: () => import(/* webpackChunkName: "h5-page" */ "@/views/h5-page/login/index.vue"),
    meta: {
      title: i18n.t("h5Page.login.title"),
      isH5Page: true,
      isH5Login: true
    }
  },
  {
    path: "/h5-login/h5-page-msg-check",
    name: "LoginMsgCheck",
    component: () => import(/* webpackChunkName: "h5-page" */ "@/views/h5-page/login/LoginMsgCheck.vue"),
    meta: {
      title: i18n.t("h5Page.login.title"),
      isH5Page: true,
      isH5Login: true
    }
  },
  //账户/组
  {
    path: "/h5-page-account",
    name: "h5PageAccount",
    component: () => import(/* webpackChunkName: "h5-page" */"@/views/h5-page/account/index.vue"),
    meta: {
      title: i18n.t("h5Page.account.title"),
      isH5Page: true,
      isH5Login: false
    }
  },
  //交易
  {
    path: "/h5-page-transaction-home",
    name: "h5PageTransactionHome",
    component: () => import(/* webpackChunkName: "h5-page" */"@/views/h5-page/transactionHome/index.vue"),
    meta: {
      title: "交易",
      isH5Page: true,
      isH5Login: false,
      isH5Axios: true
    }
  },
  //交易设置
  {
    path: "/h5-page-transaction",
    name: "h5PageTransaction",
    component: () => import(/* webpackChunkName: "h5-page" */"@/views/h5-page/transaction/index.vue"),
    meta: {
      title: i18n.t("h5Page.transaction.title"),
      isH5Page: true,
      isH5Login: false
    }
  },
  //交易设置-期货设置
  {
    path: "/h5-page-futures-setup",
    name: "futuresSetup",
    component: () => import(/* webpackChunkName: "h5-page" */"@/views/h5-page/transaction/futuresSetup/index.vue"),
    meta: {
      title: i18n.t("h5Page.futuresSetup.title"),
      isH5Page: true,
      isH5Login: false
    }
  },
  // 操作记录
  {
    path: "/h5-page-operation",
    name: "h5PageOperation",
    component: () => import(/* webpackChunkName: "h5-page" */"@/views/h5-page/operationRecords/index.vue"),
    meta: {
      title: i18n.t("h5Page.operation.title"),
      isH5Page: true,
      isH5Login: false
    }
  },
  // 执行订单
  {
    path: "/h5-page-order",
    name: "h5PageOrder",
    component: () => import(/* webpackChunkName: "h5-page" */"@/views/h5-page/order/index.vue"),
    meta: {
      title: i18n.t("h5Page.order.title"),
      isH5Page: true
    }
  },
  //账户明细
  {
    path: "/h5-page-accountDetails",
    name: "h5PageAccountDetails",
    component: () => import(/* webpackChunkName: "h5-page" */"@/views/h5-page/accountDetails/index.vue"),
    meta: {
      title: i18n.t("h5Page.accountDetails.title"),
      isH5Page: true,
      showHeader: false
    }
  },

  //注册页面首页
  {
    path: "/register",
    name: "register",
    component: () => import("@/views/register/index.vue"),
    meta: {
      showHeader: false,
      keepAlive: true,
      title: ''
    }
  },
  //注册页面第二页（设置登录密码）
  {
    path: "/register/password-setting",
    name: "password-setting",
    component: () => import("@/views/register/PasswordSetting.vue"),
    meta: {
      showHeader: true,
      title: i18n.t("register.nav_titile2")
    }
  },
  //忘记登录密码第一页
  {
    path: "/login-password-forget",
    name: "login-password-forget-step-first",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(
        /* webpackChunkName: "about" */ "@/views/login-password-forget/StepFirst.vue"
        ),
    meta: {
      showHeader: false,
      keepAlive: true,
      title: ''
    }
  },
  //忘记登录密码第二页
  {
    path: "/login-password-forget/step-second",
    name: "login-password-forget-step-second",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(
        /* webpackChunkName: "about" */ "@/views/login-password-forget/StepSecond.vue"
        ),
    meta: {
      showHeader: false,
      keepAlive: true,
      title: ''
    }
  },
  {
    path: "/login-password-forget/step-third",
    name: "login-password-forget-step-third",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(
        /* webpackChunkName: "about" */ "@/views/login-password-forget/StepThird.vue"
        ),
    meta: {
      showHeader: false,
      keepAlive: true,
      title: ''
    }
  },
  // 策略执行
  {
    path: "/h5-strategy-home",
    name: "/h5-strategy-home",
    meta: {
      title: "策略执行",
      isH5Page: true,
      isH5Login: false
    },
    component: () => import("@/views/h5-page/strategyHome/index.vue")
  },
  // 策略执行
  {
    path: "/h5-strategy-execution",
    name: "/h5-strategy-execution",
    meta: {
      title: "策略执行",
      isH5Page: true,
      isH5Login: false,
      headerHasBack: true
    },
    component: () => import("@/views/h5-page/strategyExecution/index.vue")
  },
  // 添加、编辑策略计划
  {
    path: "/h5-create-strategy",
    name: "h5CreateStrategy",
    component: () => import(/* webpackChunkName: "h5-page" */"@/views/h5-page/createStrategy/index.vue"),
    meta: {
      title: "",
      isH5Page: true,
      showHeader: false,
      headerHasBack: true
    }
  },
  // 异常消息列表
  {
    path: "/h5-exception-message",
    name: "h5ExceptionMessage",
    component: () => import(/* webpackChunkName: "h5-page" */"@/views/h5-page/exceptionMessage/index.vue"),
    meta: {
      title: "异常消息",
      isH5Page: true,
      isH5Login: false,
      headerHasBack: true
    }
  }
];
